import React, { useEffect, useState } from 'react';
import { sb } from '../services/supabase';
import { PageHeader, StatCard, Card, Table, Td, EmptyRow, Badge } from '../components/ui';

export default function Dashboard() {
  const [stats, setStats] = useState({ companies: 0, users: 0, active: 0, trial: 0 });
  const [recent, setRecent] = useState<any[]>([]);

  useEffect(() => {
    (async () => {
      const [{ data: companies }, { count: users }] = await Promise.all([
        sb.from('companies').select('*').order('created_at', { ascending: false }),
        sb.from('users').select('*', { count: 'exact', head: true }),
      ]);
      const c = companies || [];
      setStats({ companies: c.length, users: users || 0, active: c.filter((x: any) => x.is_active).length, trial: c.filter((x: any) => x.plan === 'trial').length });
      setRecent(c.slice(0, 8));
    })();
  }, []);

  return (
    <div className="animate-fadeUp" style={{ padding: 32 }}>
      <PageHeader title="Platform Overview" subtitle="ClockedIQ super admin dashboard" />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 16, marginBottom: 32 }}>
        <StatCard label="Total Companies" value={stats.companies} color="var(--accent)" />
        <StatCard label="Total Users" value={stats.users} color="#845EC2" />
        <StatCard label="Active Companies" value={stats.active} color="var(--accent)" />
        <StatCard label="On Trial" value={stats.trial} color="var(--warn)" />
      </div>
      <Card>
        <div style={{ padding: '18px 20px', borderBottom: '1px solid var(--border)', fontSize: 15, fontWeight: 700 }}>Recent Companies</div>
        <Table headers={['Company', 'Plan', 'Attendance', 'Leave', 'Payroll', 'Status', 'Created']}>
          {recent.length === 0 ? <EmptyRow cols={7} /> : recent.map(c => (
            <tr key={c.id}>
              <Td><div style={{ fontWeight: 600 }}>{c.name}</div><div style={{ fontSize: 11, color: 'var(--muted)', fontFamily: 'var(--mono)' }}>{c.slug}</div></Td>
              <Td><Badge type={c.plan || 'trial'}>{c.plan || 'trial'}</Badge></Td>
              <Td><Badge type={c.feature_attendance !== false ? 'green' : 'red'}>{c.feature_attendance !== false ? 'On' : 'Off'}</Badge></Td>
              <Td><Badge type={c.feature_leave ? 'green' : 'red'}>{c.feature_leave ? 'On' : 'Off'}</Badge></Td>
              <Td><Badge type={c.feature_payroll ? 'green' : 'red'}>{c.feature_payroll ? 'On' : 'Off'}</Badge></Td>
              <Td><Badge type={c.is_active ? 'green' : 'red'}>{c.is_active ? 'active' : 'inactive'}</Badge></Td>
              <Td mono>{new Date(c.created_at).toLocaleDateString('en-IN')}</Td>
            </tr>
          ))}
        </Table>
      </Card>
    </div>
  );
}
